import { render, staticRenderFns } from "./HmFilterGoods.vue?vue&type=template&id=52a5b772&scoped=true&"
import script from "./HmFilterGoods.vue?vue&type=script&lang=js&"
export * from "./HmFilterGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a5b772",
  null
  
)

component.options.__file = "HmFilterGoods.vue"
export default component.exports